import { toUrlId } from "@faire/retailer/models/Category/IUrlId";
import { suppliersPath } from "@faire/retailer/paths/suppliers/suppliersPath";

export enum KEYWORDS {
  DRINKWARE = "drinkware",
  PLANTER = "planter",
  MOISTURIZER = "moisturizer",
  COFFEE = "coffee",
  CANDLE = "candle",
}

export const IMAGES = () => [
  {
    keyword: KEYWORDS.DRINKWARE,
    imageUrls: [
      "https://cdn.faire.com/fastly/6164de963744276c4705cbd6565be56a2297c90095bc81fbfc76919d8f822409.jpeg",
      "https://cdn.faire.com/fastly/58fce8ff194e74fd185edc31f044f0bfb416f16ea85e1d6a4c3bd84068a6bf75.jpeg",
      "https://cdn.faire.com/fastly/00324922ee4a1346a5e6739a2f286ee6319eb1188824a5b88b36e8af809743c4.jpeg",
      "https://cdn.faire.com/fastly/27686648d8c695643ca84d99338393449cee6a15d63bae15a4e05feebf1b8e27.jpeg",
    ],
  },
  {
    keyword: KEYWORDS.PLANTER,
    imageUrls: [
      "https://cdn.faire.com/fastly/0e9e5b359c25391f9d7da05d372204d5f6e39d6012507099361c367c58093222.jpeg",
      "https://cdn.faire.com/fastly/a3284f817f630875e07ed30327c66c52a563be9078e0ba629ba2e7bfab34bb92.jpeg",
      "https://cdn.faire.com/fastly/6204b797860c97373150a31dd40f6ebd0eaa2f41ad6a5db46c0fbb3e28aa2116.jpeg",
      "https://cdn.faire.com/fastly/ac2b707428ab028e8af08bf162abd4dddba020f8467857501c9df99383c8c732.jpeg",
    ],
  },
  {
    keyword: KEYWORDS.MOISTURIZER,
    imageUrls: [
      "https://cdn.faire.com/fastly/0145a51a5d31a6a4fccedfbc573af71d4d5f2c0d55d340f301517a8d8a948b91.jpeg",
      "https://cdn.faire.com/fastly/4d6a2407e9397b29f981aee8a23d7da1a40def65839557186a093cbf3327b0d3.jpeg",
      "https://cdn.faire.com/fastly/782e8446a7988113a5d770e161803ab561c37ea6298342786deeca0321e68d13.jpeg",
      "https://cdn.faire.com/fastly/4f690facca970093bd91ac337997675a25b175a43941292e9f0311f370b56b81.jpeg",
    ],
  },
  {
    keyword: KEYWORDS.COFFEE,
    imageUrls: [
      "https://cdn.faire.com/fastly/29b50b4befb93da780e61c684730840360e3ee313c3b772b2446cb030de9c4de.jpeg",
      "https://cdn.faire.com/fastly/4cb38698c7bec3861a4b5f865a2879d2d66cea430f14920d23786020971ea689.jpeg",
      "https://cdn.faire.com/fastly/a87ae7f4255541f718a63fbc5e4732404bb81f7c6b70915d585873f459b1395f.jpeg",
      "https://cdn.faire.com/fastly/72b0b79749833c4fd89720418316524eb97c4d77522b7ca4cec1cdb4b1a56b37.jpeg",
    ],
  },
  {
    keyword: KEYWORDS.CANDLE,
    imageUrls: [
      "https://cdn.faire.com/fastly/678e038848d1cbfa2e1f05159cfbb61c3c8cd6d1bc18c614205cddbb3b0c5443.jpeg",
      "https://cdn.faire.com/fastly/b59ba9c3958b413ec1fdebacd2ca22df642a5e7a212d06bdd24aef0085b4aa08.jpeg",
      "https://cdn.faire.com/fastly/45ca391bb83b215baf777918fa3dbcf318ca0ce3be1082cbbbd73ff19c0a310b.jpeg",
      "https://cdn.faire.com/fastly/5d897f7c870b3ca144bef8c2ac2aa5cce6e784fdc1adb75124cfd8672a69268f.jpeg",
    ],
  },
];

export const getURLFromKeyword = (keyword: KEYWORDS) => {
  const KEYWORD_TO_URL = {
    [KEYWORDS.CANDLE]: {
      url: suppliersPath({
        urlIds: [
          toUrlId("Home Decor"),
          toUrlId("Candles & Holders"),
          toUrlId("Candles"),
        ],
      }),
    },
    [KEYWORDS.COFFEE]: {
      url: suppliersPath({
        urlIds: [toUrlId("Food & Drink"), toUrlId("Coffee & Tea")],
      }),
    },
    [KEYWORDS.DRINKWARE]: {
      url: suppliersPath({
        urlIds: [
          toUrlId("Home Decor"),
          toUrlId("Kitchen & Tabletop"),
          toUrlId("Drinkware"),
        ],
      }),
    },
    [KEYWORDS.MOISTURIZER]: {
      url: suppliersPath({
        urlIds: [
          toUrlId("Beauty & Wellness"),
          toUrlId("Skincare"),
          toUrlId("Creams & Moisturizers"),
        ],
      }),
    },
    [KEYWORDS.PLANTER]: {
      url: suppliersPath({
        urlIds: [
          toUrlId("Home Decor"),
          toUrlId("Garden & Outdoor"),
          toUrlId("Pots & Plants"),
        ],
      }),
    },
  };
  return KEYWORD_TO_URL[keyword].url;
};
